import { render, staticRenderFns } from "./ProgressLabelCustom.vue?vue&type=template&id=24613620&"
import script from "./ProgressLabelCustom.vue?vue&type=script&lang=js&"
export * from "./ProgressLabelCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports